<template>
    <v-container>
        <v-simple-table>
            <template v-slot:default>
                <thead>
                <tr>
                    <th class="text-left">{{ $t('key.neophyte') }}</th>
                    <th class="text-center">{{ $t('key.surveys') }}</th>
                    <th class="text-center">{{ $t('key.number') }}</th>
                    <th class="text-center">{{ $t('key.area') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="plant in plants" :key="plant.uuid">
                    <td>{{ plant.name }}</td>
                    <td class="text-center">{{ filteredSurveys(plant.uuid).length }}</td>
                    <td class="text-center">{{ plantCount(plant.uuid) }}</td>
                    <td class="text-center">{{ plantArea(plant.uuid) }}</td>
                </tr>
                </tbody>
            </template>
        </v-simple-table>
    </v-container>
</template>

<script>
    export default {
        name: 'Overview',
        computed: {
            plants() {
                let list = this.$store.getters.plantList

                // avoid duplicate total entries
                if (!list.find(p => p.uuid === 'total')) {
                    list.push({uuid: 'total', name: this.$t('key.total')})
                }

                return list
            },
            surveys() {
                return this.$store.getters.filteredSurveyList
            }
        },
        methods: {
            filteredSurveys(plantId) {
                if (plantId === 'total')
                    return this.surveys

                return this.surveys.filter(({neophyte}) => neophyte === plantId)
            },
            totalCount() {
                let list = this.surveys.map(item => (item.numberOfPlants) ? item.numberOfPlants : 0)

                // Sum up list
                return this.sumUp(list)
            },
            plantCount(plantId) {
                if (plantId === 'total')
                    return this.totalCount()

                let filtered = this.filteredSurveys(plantId)
                    .map(item => (item.numberOfPlants) ? item.numberOfPlants : 0)

                // Sum up filtered items
                return this.sumUp(filtered)
            },
            totalArea() {
                let list = this.surveys.map(item => (item.areaOfPlants) ? item.areaOfPlants : 0)

                // Sum up list
                return this.sumUp(list)
            },
            plantArea(plantId) {
                if (plantId === 'total')
                    return this.totalArea()

                let filtered = this.filteredSurveys(plantId)
                    .map(item => (item.areaOfPlants) ? item.areaOfPlants : 0)

                // Sum up filtered items
                return this.sumUp(filtered)
            },
            sumUp(list) {
                return list.reduce((a, b) => parseInt(a) + parseInt(b), 0)
            }
        }
    }
</script>

<style />
